import { SVGProps } from '@components/Icon/types';

export const Phone = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(5, 2)">
      <path
        d="M10 18.5996V20H4V18.5996H10ZM12.5996 16V4C12.5996 2.56406 11.4359 1.40039 10 1.40039H4C2.56406 1.40039 1.40039 2.56406 1.40039 4V16C1.40039 17.4359 2.56406 18.5996 4 18.5996V20L3.79395 19.9951C1.68056 19.8879 0 18.14 0 16V4C0 1.79086 1.79086 0 4 0H10C12.2091 0 14 1.79086 14 4V16C14 18.2091 12.2091 20 10 20V18.5996C11.4359 18.5996 12.5996 17.4359 12.5996 16Z"
        fill={fill}
      />
      <path
        d="M8 2.7998L8.14062 2.81445C8.4598 2.87958 8.7002 3.16159 8.7002 3.5C8.7002 3.83841 8.4598 4.12042 8.14062 4.18555L8 4.2002H6C5.6134 4.2002 5.2998 3.8866 5.2998 3.5C5.2998 3.1134 5.6134 2.7998 6 2.7998H8Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'phone';
